import './scroll-icon.scss';

/**
 * version    1.0
 * class      ScrollIcon
 * classdesc  ScrollIcon
 */
export class ScrollIcon {
  constructor() {
    this.button = document.getElementById('scroll-toggle');

    if (!this.button) return;

    // Target scroll down:
    // - se ci sono 2+ section top-level in <main> => ultima section
    // - se c'è 0/1 section => footer (fallback)
    const getDownTarget = () => {
      const main = document.getElementById('main') || document.querySelector('main');
      const footerFallback = document.getElementById('footer') || document.querySelector('footer');

      if (!main) return footerFallback;

      const topLevelSections = Array.from(main.children).filter((el) => el.tagName === 'SECTION');

      // Se c'è una sola section prendo il footer
      if (topLevelSections.length <= 1) return footerFallback;

      // Se l'ultima sezione è già visibile (pagine corte), prendo il footer
      const lastSection = topLevelSections[topLevelSections.length - 1];
      const rect = lastSection.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const isVisible = rect.top < vh && rect.bottom > 0;
      if (isVisible) return footerFallback;

      return lastSection;
    };

    const getUpTarget = () => document.getElementById('header');

    // Gestione click sul pulsante
    this.button.addEventListener('click', () => {
      if (this.button.classList.contains('down')) {
        this.target = getDownTarget();
      } else if (this.button.classList.contains('up')) {
        this.target = getUpTarget();
      }

      if (!this.target) {
        return;
      }

      this.scroll();
      this.button.classList.toggle('down');
      this.button.classList.toggle('up');
    });

    // Gestione scroll e load della pagina
    const downTarget = getDownTarget();
    if (!downTarget) {
      return;
    }

    const updateArrowState = () => {
      const targetRect = downTarget.getBoundingClientRect();
      const vh = window.innerHeight;
      const threshold = 50;
      const shouldBeUp = targetRect.top <= vh - threshold;

      if (shouldBeUp && !this.button.classList.contains('up')) {
        this.button.classList.remove('down');
        this.button.classList.add('up');
      } else if (!shouldBeUp && !this.button.classList.contains('down')) {
        this.button.classList.remove('up');
        this.button.classList.add('down');
      }
    };

    // Controllo allo scroll manuale
    window.addEventListener('scroll', updateArrowState, { passive: true });

    // Controllo al load (pagina caricata già in basso)
    updateArrowState();
  }

  scroll() {
    const y = this.target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);

    // Feature detect: se lo smooth via API non è supportato, facciamo un'animazione manuale
    const supportsSmooth = 'scrollBehavior' in document.documentElement.style;

    if (supportsSmooth) {
      window.scrollTo({ top: y, behavior: 'smooth' });
      return;
    }

    // Fallback per iOS 14 Safari: animazione rAF
    const startY = window.pageYOffset || document.documentElement.scrollTop;
    const diff = y - startY;
    const duration = 350;
    const start = performance.now();
    const easeInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - ((-2 * t + 2) ** 2) / 2);
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      window.scrollTo(0, startY + diff * easeInOut(t));
      if (t < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }
}
